module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_08.098e8fb9.png";